import * as React from "react";
import {createElement as h} from "react";

export const Static = ({getInitValue=undefined, initValue=undefined, props=undefined, next}) => h(Static1, {getInitValue, initValue, props, next});

interface P {
    getInitValue;
    initValue;
    value;
    next;
}
interface S {
}
export class Static1 extends React.Component<P,S> {
    value;

    constructor(props, context) {
        super(props, context);

        this.value = props.getInitValue ? props.getInitValue() : props.initValue !== undefined ? props.initValue : props.value;
    }
    render() {
        const {next} = this.props;

        return next(this.value);
    }
}
